const cartTotal = new Event('cartTotal')
export default cartTotal
